import React, { cloneElement } from 'react';
import { FilterState, focusOnSearchFilter } from '@Component/Filter/utils.ts';
import { Filters, SearchFilter } from '@tlx/astro-shared';
import { useKeyboardShortcut } from '@Hooks/useKeyboardShortcut.ts';
import { SEARCH_KEY_COMBINATIONS } from '@Util/getKeyboardEventKeybinding.ts';
import { useIntl } from 'react-intl';
import { tableFilters, TableWithFilters } from '@Component/Filter/filters.tsx';

interface TableFiltersProps {
    filterState: FilterState;
    tableType: TableWithFilters;
}

export const TableFilters: React.FC<TableFiltersProps> = ({ filterState, tableType }) => {
    useKeyboardShortcut(SEARCH_KEY_COMBINATIONS, focusOnSearchFilter);
    const intl = useIntl();
    const filterComponents = tableFilters[tableType];

    const onlySearch = Object.keys(filterState).length === 1 && filterState.searchFilter !== undefined;

    return (
        <>
            {onlySearch ? (
                <div className="atl-filter-bar">
                    <SearchFilter {...filterState.searchFilter} />
                </div>
            ) : (
                <Filters>
                    {Object.entries(filterState).map(([key, filter]) =>
                        cloneElement(
                            filterComponents[key]({
                                filter,
                                intl,
                            }),
                            { key },
                        ),
                    )}
                </Filters>
            )}
        </>
    );
};
